import { useEffect, useCallback, useState } from 'react';
// import { withStyles } from '@material-ui/core/styles';
// import { makeStyles } from '@material-ui/core/styles';
// import { Fab } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';

import ReactApiService from '../../services/reactApiService'

/*
const DeleteButton = withStyles((theme) => ({
	root: {
		backgroundColor: '#00c8f4',
    '&:hover': {
      backgroundColor: '#90caf9',
    },	
	}
}))(Fab);
// */

// 
export default function ButtonEdit(props) {
	
	// const classes = useStyles();
  const [values, setValues] = useState({
    mask: false,
		rowClassWrapper: false
  });
	
	// keep function reference.
  const deleteMask = useCallback(() => {
		
		return;
		
		const dataService = new ReactApiService();
		dataService.post({endpoint:'updateMasks',body:{masks:'masks',action:'updateMasks'}})
			.then( 
				(response) => {
					// setContent((prev) => response);
					// setValues({ ...values, ['mask']: false, ['rowClassWrapper']: false });
				},
				(error) => {}
			).then(() => {
					let elems = document.getElementsByClassName(values.rowClassWrapper)
					// console.log('elems::', elems.length);
					if ( elems.length === 1 ) {
						elems[0].style.display = 'none';
					}
				}
			)
		// */	
  }, [values]) 	
	
	useEffect(() => {
		// console.log(' useEffect values::', values);
		if ( false !== values.mask ) {
			// deleteMask();
			// @see switcher.js works without `values` param
		}
	  return () => {
			// console.log('return from useEffect content changed:: ');
	  }		
	},[values,deleteMask]);

	const handleClick = (e) => {
		let dataset = e.target.parentNode.dataset;
		if ( 'undefined' !== typeof dataset.mask ) {
			setValues({ 
				...values, 
				'mask': dataset.mask,
				'rowClassWrapper': props.rowClassWrapper+'-'+dataset.id
			});
		}
	}
	
	const getClasses = () => {
		let classes = 'button-action button-edit';
		if ( ! props.editable ) {
			classes += ' button-hidden';
		}
		return classes
	}

  return (
			<span className={getClasses()} data-id={props.params.id} data-mask={props.params.row.mask} onClickCapture={handleClick}  >		
				<EditIcon 
					className={'edit-icon'} 
					size='small'
					color='primary' 
					aria-label='edit'
					data-id={props.params.id} 
					data-mask={props.params.row.mask} />
			</span>						
  );
}
